import { prop } from 'ramda';
import { makeModuleAsync } from '@/utils';
import { measures as endpoint } from '@/config/endpoints';

const parseApiResponse = prop('grouped_measures');

export default makeModuleAsync({ endpoint, parseApiResponse });
